"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var experiment = _ref.experiment;
  var variant = _ref.variant;
  return {
    experimentName: experiment + ":" + variant
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/utils/getExperimentLinkName.js
 ** module id = 431
 ** module chunks = 0
 **/